import React from "react";
import { Button } from "../button/Button";
import { ButtonRow } from "../button/ButtonRow";

type CloseModalButtonProps = {
    onClose:()=>void,
    buttonText?:string,
    buttonDisabled?:boolean
}
export function CloseModalButton(props:CloseModalButtonProps):JSX.Element
{
    return (
        <ButtonRow variant='right-aligned'>
            <Button variant='filled' text={props.buttonText || 'Luk'} onClick={props.onClose} disabled={props.buttonDisabled} />
        </ButtonRow>
    );
}